import { Loader } from '@googlemaps/js-api-loader';
import { googleMapKey } from '@client/pages/activity-detail/sidebar/sport-map/SportMap/constant';

let GmapClass;
let godvMapInstance;
let language = 'en';

export async function getGmapInstance({ id } = {}) {
  if (!id) {
    return;
  }

  if (godvMapInstance) {
    return Promise.resolve(godvMapInstance);
  }

  await getGmapConstructor();

  godvMapInstance = new GmapClass.Map(document.getElementById(id));

  return godvMapInstance;
}

export async function getGmapConstructor(locale) {
  if (locale) {
    language = locale.split('-')[0];
  }
  if (GmapClass) {
    return Promise.resolve(GmapClass);
  }

  const sdkLoader = new Loader({
    apiKey: googleMapKey,
    version: 'weekly',
    language
  });
  await sdkLoader.load();
  // eslint-disable-next-line no-undef
  if (!GmapClass) GmapClass = google.maps;

  return GmapClass;
}
